// Reads the file name out of a Content-Disposition header. Rails sends both a quoted
// `filename=` and an encoded `filename*=`; the encoded one wins when it's present.
export const filenameFromContentDisposition = (header) => {
  if (!header) return null;

  const encoded = header.match(/filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch {
      // Malformed encoding: fall back to the plain file name
    }
  }

  const plain = header.match(/filename\s*=\s*(?:"([^"]*)"|([^;]+))/i);
  return plain ? (plain[1] ?? plain[2]).trim() : null;
};
